var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgInfo = function SvgInfo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.3c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7-7.7-3.5-7.7-7.7S7.8 4.3 12 4.3M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.57 10.84c-.17.04-.33.2-.38.37-.02.07-.02.2 0 .27.05.18.2.33.37.37.06.01.09.02.49.02h.43v3.52H9.94l-.05.02c-.08.03-.15.07-.21.14q-.15.15-.15.36c0 .24.16.45.39.51l.06.02h4.05l.06-.02c.14-.04.27-.14.33-.28.04-.08.06-.16.05-.26 0-.14-.05-.24-.15-.34a.47.47 0 0 0-.21-.13l-.05-.02h-1.54v-2.04c0-2.2 0-2.1-.04-2.2a.56.56 0 0 0-.32-.3l-.05-.02h-1.55",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.94a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7"
  })));
};
export { SvgInfo as ReactComponent };
export default __webpack_public_path__ + "static/media/info.2cf8f5200f6322aaa2a0d7cfc636d055.svg";